module.exports = __webpack_public_path__ + "static/media/US-UK_Apple_Music_Badge_RGB.0d25cc45.svg";